module.exports = __webpack_public_path__ + "static/media/Chow.ab5727a3.jpg";